// MoonBundle Variant Subscriber
// This script subscribes to variant changes and updates submit button state

(function() {
  'use strict';
  
  function initMoonBundleSubscribers(retryCount = 0) {
    console.log('[MoonBundle Subscriber] Initializing... (attempt', retryCount + 1, ')');
    
    if (typeof window.MoonBundle === 'undefined') {
      console.log('[MoonBundle Subscriber] window.MoonBundle is undefined');
      return;
    }
  
    const bundleIds = Object.keys(window.MoonBundle);
    console.log('[MoonBundle Subscriber] Found bundle IDs:', bundleIds);
    
    if (bundleIds.length === 0) {
      console.log('[MoonBundle Subscriber] No bundles found');
      
      // Retry up to 10 times if no bundles found
      if (retryCount < 10) {
        console.log('[MoonBundle Subscriber] Retrying in 200ms...');
        setTimeout(() => {
          initMoonBundleSubscribers(retryCount + 1);
        }, 200);
      } else {
        console.log('[MoonBundle Subscriber] Max retries reached, giving up');
      }
      return;
    }
    
    console.log('[MoonBundle Subscriber] Found', bundleIds.length, 'bundle(s), setting up subscribers');
    
    bundleIds.forEach(bundleId => {
      console.log('[MoonBundle Subscriber] Processing bundle:', bundleId);
      
      const bundle = window.MoonBundle[bundleId];
      
      if (!bundle || !bundle.currentOffer || !bundle.variants) {
        console.log('[MoonBundle Subscriber] Bundle missing required properties:', bundleId);
        return;
      }
      
      if (typeof bundle.currentOffer.subscribe !== 'function' || 
          typeof bundle.variants.subscribe !== 'function') {
        console.log('[MoonBundle Subscriber] Subscribe functions not available:', bundleId);
        return;
      }
      
      console.log('[MoonBundle Subscriber] Setting up subscribers for:', bundleId);
      
      function updateSubmitButton(offer, variants) {
        console.log('[MoonBundle Subscriber] updateSubmitButton called', {
          bundleId,
          offer,
          variants
        });
        
        const currentOfferId = offer?.id || offer;
        console.log('[MoonBundle Subscriber] Current offer ID:', currentOfferId);
        
        const moonbundleComponent = document.getElementById(bundleId);
        let mainProductVariants = [];
        let hasSelectYourSize = false;
        let isOutOfStock = false;
        
        console.log('[MoonBundle Subscriber] Component found:', !!moonbundleComponent);
        
        if (moonbundleComponent && moonbundleComponent.tagName.toLowerCase() === 'moonbundle-component') {
          try {
            const mainProductAttr = moonbundleComponent.getAttribute('main-product');
            if (mainProductAttr) {
              const mainProduct = JSON.parse(mainProductAttr.replace(/&quot;/g, '"'));
              mainProductVariants = mainProduct.variants || [];
              console.log('[MoonBundle Subscriber] Main product variants loaded:', mainProductVariants.length);
            }
          } catch (e) {
            console.error('[MoonBundle Subscriber] Error parsing main-product:', e);
          }
        }
        
        if (typeof variants === 'object' && variants !== null) {
          let currentOfferVariants = null;
          
          if (variants.offers && typeof variants.offers === 'object') {
            currentOfferVariants = variants.offers[currentOfferId];
          } else if (currentOfferId && variants[currentOfferId]) {
            currentOfferVariants = variants[currentOfferId];
          }
          
          if (currentOfferVariants && typeof currentOfferVariants === 'object') {
            Object.values(currentOfferVariants).forEach(variantData => {
              if (Array.isArray(variantData)) {
                variantData.forEach(variant => {
                  const variantId = typeof variant === 'object' ? variant.id : variant;
                  const matchingVariant = mainProductVariants.find(v => v.id === variantId);
                  
                  if (matchingVariant) {
                    if (matchingVariant.title && matchingVariant.title.includes('Select your size')) {
                      hasSelectYourSize = true;
                    } else if (!matchingVariant.available) {
                      isOutOfStock = true;
                    } 
                  }
                });
              }
            });
          }
        }
        
        const productInfo = document.querySelector('product-info');
        
        console.log('[MoonBundle Subscriber] product-info found:', !!productInfo);
        
        if (productInfo) {
          const forms = productInfo.querySelectorAll('form');
          let submitButton = null;
          
          console.log('[MoonBundle Subscriber] Forms found:', forms.length);
          
          for (const form of forms) {
            const instanceIdInput = form.querySelector('input[name="instance-id"]');
            if (instanceIdInput && instanceIdInput.value === bundleId) {
              submitButton = form.querySelector('button[type="submit"]');
              console.log('[MoonBundle Subscriber] Submit button found:', !!submitButton);
              break;
            }
          }
          
          if (submitButton) {
            console.log('[MoonBundle Subscriber] Button state:', {
              hasSelectYourSize,
              isOutOfStock
            });
            
            if (hasSelectYourSize) {
              submitButton.textContent = 'SELECT YOUR SIZE';
              submitButton.disabled = true;
              submitButton.style.opacity = '0.5';
              submitButton.style.cursor = 'not-allowed';
              console.log('[MoonBundle Subscriber] Button set to: SELECT YOUR SIZE');
            } else if (isOutOfStock) {
              submitButton.textContent = 'OUT OF STOCK';
              submitButton.disabled = true;
              submitButton.style.opacity = '0.5';
              submitButton.style.cursor = 'not-allowed';
              console.log('[MoonBundle Subscriber] Button set to: OUT OF STOCK');
            } else {
              submitButton.disabled = false;
              submitButton.style.opacity = '';
              submitButton.style.cursor = '';
              submitButton.textContent = 'ADD TO CART';
              console.log('[MoonBundle Subscriber] Button set to: ADD TO CART');
            }
          } else {
            console.log('[MoonBundle Subscriber] Submit button not found');
          }
        }
      }
      
      const unsubscribeOffer = bundle.currentOffer.subscribe(offer => {
        console.log('[MoonBundle Subscriber] Offer changed:', offer);
        const variants = bundle.variants.get();
        updateSubmitButton(offer, variants);
      });
      
      const unsubscribeVariants = bundle.variants.subscribe(variants => {
        console.log('[MoonBundle Subscriber] Variants changed:', variants);
        const offer = bundle.currentOffer.get();
        updateSubmitButton(offer, variants);
      });
      
      // Initial update
      console.log('[MoonBundle Subscriber] Running initial update');
      const initialOffer = bundle.currentOffer.get();
      const initialVariants = bundle.variants.get();
      updateSubmitButton(initialOffer, initialVariants);
      
      console.log('[MoonBundle Subscriber] Subscriptions complete for:', bundleId);
      
      if (!window._moonBundleUnsubscribers) {
        window._moonBundleUnsubscribers = {};
      }
      window._moonBundleUnsubscribers[bundleId] = {
        offer: unsubscribeOffer,
        variants: unsubscribeVariants
      };
    });
  }

  // Wait for window.MoonBundle to exist
  console.log('[MoonBundle Subscriber] Script loaded, checking for window.MoonBundle...');
  
  if (typeof window.MoonBundle !== 'undefined') {
    console.log('[MoonBundle Subscriber] window.MoonBundle already exists');
    initMoonBundleSubscribers();
  } else {
    console.log('[MoonBundle Subscriber] Waiting for window.MoonBundle...');
    const checkInterval = setInterval(function() {
      if (typeof window.MoonBundle !== 'undefined') {
        console.log('[MoonBundle Subscriber] window.MoonBundle detected!');
        clearInterval(checkInterval);
        initMoonBundleSubscribers();
      }
    }, 100);
    
    setTimeout(function() {
      console.log('[MoonBundle Subscriber] Timeout reached, stopping checks');
      clearInterval(checkInterval);
    }, 10000);
  }
  
})();